'use client';

import { Flex, IconButton, Text } from '@chakra-ui/react';
import { Trash2Icon } from 'lucide-react';
import { useTranslations } from 'next-intl';

interface BrandHeaderProps {
  brandName: string;
  onClear: () => void;
}

export default function BrandHeader({ brandName, onClear }: BrandHeaderProps) {
  const t = useTranslations();

  return (
    <Flex justify='space-between' w='full' align='center' mb={3} position='relative'>
      <Text color='text' fontWeight={600}>
        {brandName}
      </Text>
      <IconButton
        size='sm'
        rounded='xl'
        variant='ghost'
        onClick={onClear}
        position='absolute'
        aria-label={t('clear')}
        transform='translateY(-7px)'
        _hover={{ bg: 'background' }}
        right={0}
        top={0}
      >
        <Trash2Icon size={20} />
      </IconButton>
    </Flex>
  );
}
